import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-dmc-package-notes',
  templateUrl: './dmc-package-notes.component.html',
  styleUrls: ['./dmc-package-notes.component.scss'],
})
export class DmcPackageNotesComponent implements OnInit {

  @Input() packageId: any;
  @Input() storedFormData: any;

  @Input() editPackageId: any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();
  @Output() openReviewScreen: EventEmitter<any> = new EventEmitter<any>();

  notesForm!: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _globalService: GlobalService,
    private _dmcPackageService: DmcPackageService,
    private _responseNotificationService : ResponseNotificationService
  ) { }

  ngOnInit() {
    this.notesForm = this._fb.group({
      note: [''],
      packageId: [this.packageId],
      id: [null],
      ownership: [null],
      organizationId: [null],
      createDate: [null],
      createdBy: [null]
    });

    this.notesForm.valueChanges.subscribe(() => {
      this.notesForm.markAsTouched();
    })

    if (this.storedFormData) {
      this.notesForm.patchValue(this.storedFormData)
    }
  }

  async onSubmit(): Promise<boolean>{
    if(this.notesForm.valid){
      let formData = this.notesForm.value;
          
      return new Promise((resolve) => {
        this._dmcPackageService.addNotes(formData).subscribe({
          next: (data: any) => {
            this.storeFormData.emit(data);
          },
          error: (error) => {
            console.error('Error saving Notes: ', error);
            this._responseNotificationService.showMessage("Error saving Notes", true);
            resolve(false);
          },
          complete: () => {
            this.notesForm.markAsPristine();
            this._responseNotificationService.showMessage("Notes added successfully");
            resolve(true);
          }
        });
      });
    }else{
      this.notesForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false; 
    }
  }
  
  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return  this.notesForm.touched && (this.notesForm.dirty || this.notesForm.invalid);
  }
}
